<template>
  <a-card :bordered="false" title="关联商品">
    <div>
      <a-button type="primary" @click="addProduct">新增</a-button>
    </div>
    <custom-page-table
      style="margin-top:16px;"
      ref="tableList"
      :queryParams="queryParams"
      :columns="columns"
      :requestPromise="getProductList"
    >
      <span slot="joinProCatalog" slot-scope="rowItem">
        {{ rowItem.text | getAllProductTypeName }}
      </span>
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm title="是否要删除当前标签？" @confirm="deleteProduct(rowItem.record)">
          <a-button size="small" type="primary">移除</a-button>
        </a-popconfirm>
      </span>
    </custom-page-table>
    <a-modal title="新增商品" :footer="null" :width="850" :visible="visible" @cancel="handleCancel">
      <a-row :span="24" style="margin-bottom: 40px">
        <a-col :span="23">
          <a-input v-model="queryProduct.proId" style="width: 200px;margin-right: 20px" placeholder="商品ID"></a-input>
          <a-input
            v-model="queryProduct.proName"
            style="width: 200px;margin-right: 20px"
            placeholder="商品名称"
          ></a-input>
          <a-select
            style="width: 200px;margin-right: 20px"
            v-model="queryProduct.proCatalog"
            placeholder="请选择商品类型"
          >
            <a-select-option :value="1">门票</a-select-option>
            <a-select-option :value="2">酒店</a-select-option>
            <a-select-option :value="83">预约</a-select-option>
            <a-select-option :value="8">抢购</a-select-option>
          </a-select>
          <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
        </a-col>
      </a-row>
      <custom-page-table
        style="margin-top:16px;"
        ref="table"
        :queryParams="queryProduct"
        :columns="columnsProduct"
        base-key="proUrl"
        query-path="notify/get/MerchantPro"
      >
        <span slot="proCatalog" slot-scope="rowItem">
          {{ rowItem.record.proCatalogId | getAllProductTypeName }}
        </span>
        <span slot="action" slot-scope="rowItem">
          <a-button size="small" type="primary" @click="selectedProductEvent(rowItem.record)">选择</a-button>
        </span>
      </custom-page-table>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'ResourceControlList_BindProduct',
  data() {
    return {
      queryParams: {},
      columns: [
        {
          title: 'ID',
          dataIndex: 'joinProId'
        },
        {
          title: '商品名称',
          dataIndex: 'joinProName'
        },
        {
          title: '类型',
          dataIndex: 'joinProCatalog',
          scopedSlots: { customRender: 'joinProCatalog' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      columnsProduct: [
        {
          title: 'ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '420px'
        },
        {
          title: '类型',
          dataIndex: 'proCatalog',
          scopedSlots: { customRender: 'proCatalog' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      projectId: this.$route.query.projectId,
      visible: false,
      queryProduct: {},
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ResourceControlList', title: '项目列表' },
      { name: 'PushOrder', title: '推送订单' },
      { name: 'BatchOrder', title: '批量导单' },
      { name: 'CommodityList', title: '商品列表' }
    ])
    this.queryProduct = {
      merchantId: this.merchantId,
      proCatalog: 1
    }
  },
  mounted() {
  },
  methods: {
    getProductList(params) {
      const url =
        'itemPro/get/joinList?pageNum=' +
        params.limitDto.pageNum +
        '&pageSize=' +
        params.limitDto.pageSize +
        '&itemId=' +
        this.projectId
      return this.getHttpServices()
        .getResourceService()
        .post(url)
    },
    //商品选择事件
    selectedProductEvent(item) {
      this.addOrDeleteProduct(item, 1)
      this.visible = false
    },
    // 删除关联商品
    deleteProduct(item) {
      this.addOrDeleteProduct(item, 2)
    },
    /**
     *  添加或者删除商品
     * @param item  选中商品
     * @param joinType   操作类型 1绑定项目 2删除绑定 ,
     * @returns {Promise<unknown>}
     */
    addOrDeleteProduct(item, joinType) {
      const params = {
        joinType: joinType,
        joinProCatalog: joinType === 1 ? item.proCatalogId : item.joinProStatus,
        joinProName: joinType === 1 ? item.proName : item.joinProName,
        joinProStatus: joinType === 1 ? item.proStatus : item.joinProStatus,
        joinProId: joinType === 1 ? item.proId : item.joinProId,
        joinItemId: this.projectId,
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices()
        .getResourceService()
        .post('itemPro/changeJoin', params)
        .then(res => {
          this.$message.success(joinType == 1 ? '添加商品成功' : '删除商品成功')
          if (joinType == 1) {
            this.$refs.table.refresh(true)
          }
          this.$refs.tableList.refresh(true)
        })
        .catch(err => this.getLogUtils().logWithTag('err', err))
    },
    handleCancel() {
      this.visible = false
    },
    addProduct() {
      this.visible = true
    }
  }
}
</script>
<style scoped>
</style>
